import { IResourceConfig } from '@/Core/Contracts/UI'
import { DictionariesShell } from '../Components/DictionariesShell/DictionariesShell'
import { dictionaryDeleteConfirmText, dictionaryDetailButtons } from '../Helpers/dictionaryDelete'

export const ListClusterResponsibleResource: IResourceConfig = {
    title: 'Відповідальні за кластер',
    fields: {
        id: {
            label: 'ID',
            type: 'number',
            inputProps: { disabled: true },
            /** У фільтрі: оператор (=, >, ≥, <, ≤) або діапазон від–до */
            isFilterRange: true,
        },
        /** Порожня — бекенд будує «Кластер — Ім'я Прізвище, …» з кластера й відповідальних */
        title: {
            label: 'Назва',
            type: 'string',
            inputProps: { placeholder: 'Згенерується автоматично' },
        },
        isActive: {
            label: 'Активний',
            type: 'switch',
        },
        /** Запис завжди належить кластеру (cluster_id NOT NULL на бекенді) */
        cluster: {
            label: 'Кластер',
            isRequired: true,
            type: 'select',
            resource: 'Setting.ListCluster',
            /** У фільтрі — кілька кластерів (cluster in […]) */
            isFilterMultiple: true,
            inputProps: {
                filter: {
                    isActive: true,
                },
            },
        },
        /** Щонайменше одна особа — бекенд відхиляє порожній список (422) */
        responsibles: {
            label: 'Відповідальні особи',
            isRequired: true,
            type: 'select',
            isMultiple: true,
            resource: 'Setting.User',
            /** У фільтрі — записи, де відповідальний хоча б один із обраних */
            isFilterMultiple: true,
            inputProps: {
                filter: { status: 'active' },
                responseLabel: (item: any) =>
                    item?.fullName || `${item?.lastName || ''} ${item?.firstName || ''}`.trim() || '—',
            },
        },
        code: {
            label: 'Код',
            isRequired: true,
            type: 'string',
            depFn: ({ formContext, field }) => {
                field.mergeInputProps({ disabled: formContext.values?.id > 0 })
            },
        },
        externalCode: {
            label: 'Унікальний код ERP',
            type: 'string',
        },
        sorting: {
            label: 'Сортування',
            type: 'number',
        },
    },
    filter: {
        includeFields: ['id', 'title', 'code', 'isActive', 'cluster', 'responsibles', 'externalCode'],
    },
    /** Картка колекції всередині оболонки розділу «Довідники» */
    layout: DictionariesShell,
    restUrl: '/services/lists/cluster-responsibles',
    pageUrl: '/settings/cluster-responsibles',
    primaryFieldCode: 'code',
    /** «Видалити» в шапці картки (ядро дає лише пункт у меню рядка) */
    detailConfig: { onButtons: dictionaryDetailButtons },
    settings: {
        /** Попередження в підтвердженні видалення запису з ERP */
        deleteConfirmText: dictionaryDeleteConfirmText,
        searchFields: ['id', 'code', 'title'],
    },
}
